module.exports = __webpack_public_path__ + "img/rvdsb-1@small.b88e2a70.png";